<script>
	import { Router, Link, Route } from "svelte-routing";
	import Home from './Home.svelte';
	import FAQ from './FAQ.svelte';
	import Results from './Results.svelte';
	import Impressum from './Impressum.svelte';
	import Datenschutz from './Datenschutz.svelte';
	import { fade } from 'svelte/transition';

	import IconifyIcon from '@iconify/svelte';
	import menuIcon from '@iconify-icons/mdi/menu';
	import MediaQuery from "./MediaQuery.svelte";

	export let url = "";

	let hideMobileMenu = true;

	function toggleMobileMenu() {
		hideMobileMenu = !hideMobileMenu;
	}



</script>
<Router url="{url}">
	<nav class="main-nav">
		<a href="https://www.estandards-mittelstand.de/" class="logo-link" target="blank"><img src="./img/logo.png" class="logo" alt="Logo Mittelstand 4.0 Kompetenzzentrum eStandards"></a>

		<!-- nav  -->
		<MediaQuery query="(min-width: 767px)" let:matches>
			{#if matches}
			<ol class="main-nav-items">
				<li><Link to="/" class="nav-link"><strong>CO<sub>2</sub>ptimizer</strong></Link></li>
				<li><a href="https://www.estandards-mittelstand.de/ueber-uns/" target="blank" class="nav-link">Über uns</a></li>
				<li><Link to="faq" class="nav-link">FAQ</Link></li>
				<li><a href="https://www.estandards-mittelstand.de/kontakt/" target="blank" class="nav-link">Kontakt</a></li>
			</ol>
			{/if}
		</MediaQuery>
		<!-- /nav  -->

		<!-- mobile-nav  -->
		<MediaQuery query="(max-width: 766px)" let:matches>
			{#if matches}
			<button  on:click={toggleMobileMenu} class="mobile-menu-btn">
				<IconifyIcon icon={menuIcon} width="2em"/>
			</button>

			<ol class={`main-nav-items-mobile ${hideMobileMenu ? ' collapsed' : ''}`} on:click={toggleMobileMenu}>
				<li><Link to="/" class="nav-link"><strong>CO<sub>2</sub>ptimizer</strong></Link></li>
				<li><a href="https://www.estandards-mittelstand.de/ueber-uns/" target="blank" class="nav-link">Über uns</a></li>
				<li><Link to="faq" class="nav-link">FAQ</Link></li>
				<li><a href="https://www.estandards-mittelstand.de/kontakt/" target="blank" class="nav-link">Kontakt</a></li>
			</ol>
			{/if}
		</MediaQuery>
		<!-- /mobile-nav  -->
	</nav>

	<main in:fade out:fade>
		<Route path="faq" component="{FAQ}" />
		<Route path="results" component="{Results}" />
		<Route path="impressum" component="{Impressum}" />
		<Route path="datenschutz" component="{Datenschutz}" />
		<Route path="/"><Home /></Route>
	</main>

	<footer>
		<nav class="footer-nav">
			<ol class="footer-nav-items">
				<li><Link to="impressum" class="footer-link">Impressum</Link></li>
				<li><Link to="datenschutz" class="footer-link">Datenschutzinformation</Link></li>
			</ol>

			<a href="https://www.websitecarbon.com/" target="blank" class="footer-link" style="padding-top: 1em;">Powered by Website Carbon</a>
		</nav>
		<div class="footer-logos">
			<div>
				<img src="./img/footer-logos.jpg" alt="Logos Mittelstand Digital und Bundesministeriums für Wirtschaft und Energie" width="595px" />
			</div>					
		</div>
	</footer>
</Router>

<style>

	:root {
		/* all CSS vars live here! */
		--menu-height: 80px; /* used also for top-margin of main-img in Home */

		/*  color scheme

			please define ALL und JUST colors here
			if you have a semantic assignment of a color
			assign it in the next section
		*/
		--yellow: #F2B035;
		--green: #328C52;
		--red: #F25430;
		--black: #000000;
		--white: white; /* this might seem redundant, but will make us very happy, if one day we decide that white might just be a slightly off-white shade */
		
		--ci-gray-20: rgba(0, 0, 0, 0.2);
		--ci-gray-10: rgb(237, 237, 237);
		--ci-red: rgb(181, 9, 0);
		--ci-red-dark: rgb(104, 28, 65);

		/* semantic color assignments */
		--bg-color: var(--ci-gray-10);
		--alt-bg-color: var(--white);
		--text-color: var(--black);
		--alt-text-color: var(--ci-red);
		--link-color: var(--ci-red);
		--link-color-visited: var(--ci-red-dark);
		--nav-link-color: var(--black);
		--nav-link-active-color: var(--ci-red);
		--separator-color: var(--black);
		--btn-color: var(--ci-red);
		--highlight-text-color: var(--ci-red);


		background-color: var(--bg-color);
		padding: 0;
		margin: 0;
		text-align: left;
	}

	:global(a) {
		color: var(--link-color);
		font-weight: 700;
	}

	:global(a:hover) {
		color: var(--link-color-visited);
	}

	:global(a:visited) {
		color: var(--link-color-visited);
	}

	:global(button) {
		cursor: pointer;
		background-color: var(--btn-color);
		border-color: var(--btn-color);
		color: var(--white);
		height: fit-content;
		box-sizing: border-box;
		border-radius: 8px;
		padding: 0.5em 2em;
		color: white;
		font-weight: 600;
		cursor: pointer;
	}

	:global(button:hover) {
		opacity: 0.8;
	}

	main {
		text-align: left;
		padding: 0;
		margin: 0 auto;
	}

	:global(.alt-bg){
		background: var(--alt-bg-color);
	}

	:global(.normal-bg){
		background: var(--bg-color);
	}

	:global(.content-box) {
		padding: 2em;
		display: flex;
		flex-direction: column;
	}

	@media only screen and (min-width: 768px) {
		:global(.content-box) {
			padding-top: 5em;
			padding-bottom: 5em;
			flex-direction: row;
		}
	}

	:global(.round-corner) {
		border-radius: 1em;
	}

	:global(.highlighted-text) {
		color: var(--alt-text-color);
	}

	:global(.big-text) {
		font-size: 1.3em;
	}

	:global(.flex-row) {
		display: flex;
		flex-direction: row;
	}

	:global(.flex-col) {
		display: flex;
		flex-direction: column;
	}

	:global(.fit-content) {
		width: fit-content;
	}

	:global(.m-auto) {
		margin: auto;
	}

	:global(.bubble) {
		border-radius: 1em;
		padding: 0.5em 2em;
	}

	.logo{
		margin: 20px;
		height: 50px;
	}

	.logo-link {
		z-index: 4;
	}

	.mobile-menu-btn{
		border: 0;
		background: transparent;
		color: var(--ci-red);
		z-index: 3;
	}

	.main-nav {
		display: flex;
		justify-content: space-between;
		height: var(--menu-height);
	}

	.main-nav-items-mobile.collapsed{
		display: none !important;
	}

	.main-nav-items-mobile {
		display: flex !important;
		flex-direction: column;
		list-style: none;
		position: absolute;
		margin-top: 80px;
		background: var(--ci-gray-10);
		width: 100%;
		z-index: 2;
	}

	.main-nav ol li{
		padding: 1em;
	}

	.footer-nav :global(.footer-link) {
		font-weight: normal;
	}

	.footer-nav :global(.footer-link),
	.main-nav .main-nav-items :global(.nav-link) {
		color: var(--nav-link-color);
	}

	.footer-nav :global(.footer-link:hover),
	.main-nav .main-nav-items :global(.nav-link:hover)  {
		color: var(--nav-link-active-color);
	}

	.footer-nav :global(.footer-link.active),
	.main-nav .main-nav-items :global(.nav-link.active) {
		color: var(--nav-link-active-color);
	}

	footer{
		display: flex;
		flex-direction: column;
		padding-top: 2em;
	}

	.footer-nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding-left: 1em;
		padding-right: 1em;
	}

	@media only screen and (max-width: 767px) {
		.footer-nav {
			flex-direction: column;
		}
	}

	.footer-nav-items {
		list-style: none;
		padding-left: 0;
		display: flex;
		flex-direction: row;
	}

	.footer-nav-items  li{
		margin-right: 1em;
	}

	.footer-logos{
		margin-top: 2em;
		padding: 1em;
		display: flex;
		justify-content: flex-end;
		background-color: white;
	}

	@media only screen and (max-width: 767px) {
		.footer-logos{
			flex-direction: column;
		}
	}

	/* media queries */
	@media only screen and (min-width: 768px) {
		.main-nav-items{
			display: flex !important;
			z-index: 2;
		}

		.main-nav ol {
			display: flex;
			flex-direction: row;
			list-style: none;
		}
	}

</style>